import { create } from 'apisauce'
import Cookies from 'universal-cookie';

const getCsrfToken = () => {
  const cookies = new Cookies();
  return cookies.get('csrf_token');
};

const createApi = (baseURL) => {
  const instance = create({
    baseURL: baseURL,
    withCredentials: true
  });

  // Add request transform to inject fresh CSRF token before each request
  instance.addRequestTransform(request => {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      request.headers['x-csrf-token'] = csrfToken;
    }
  });

  instance.addResponseTransform(response => {
    if ((response.status === 401 || response.status === 403) && !response.headers['no-redirect']) {
      window.location.href = `${import.meta.env.REACT_APP_OAUTH_URL}/login?next=${encodeURI(window.location.href)}`;
    }
  });
  return instance;
}

export const performLogout = async (oauth2Url) => {
  const logoutInstance = create({
    baseURL: oauth2Url,
    withCredentials: true
  });
  await logoutInstance.post('/logout' + encodeURI(oauth2Url), {});
}

const api = createApi(`${import.meta.env.REACT_APP_API_ROOT}`);
export const api2 = createApi(`${import.meta.env.REACT_APP_PUBLIC_API_URL}`);
export const dataorchApi = createApi(`${import.meta.env.REACT_APP_DATAORCH}`);
const oauth2Api = createApi(`${import.meta.env.REACT_APP_OAUTH_API}`);

export const getReport = (id) => api.get(`/reports/uploaded/${id}`);
export const requestReport = (request) => api.post(`/reports/${request.type}/request`, request);
export const getEventTemplate = (targets, owners) => dataorchApi.get('/event-template', {targets, owners});
export const getShipmentHistory = (shipmentId) => api.get('/shipments/' + shipmentId + '/history')
export const updateShipmentTime = (shipmentId, body) => api.post(`/shipments/${shipmentId}/dropoff-time`, body);
export const checkDuplicates = (jobID) => api.get(`/jobs/draft/${jobID}/check-duplicates`)
export const updateDropoffInfo = (shipmentId, payload) => api.put(`/shipments/${shipmentId}/delivery-address`, payload);
export const getAppFeatures = (owners) => dataorchApi.get(`/app-features/filtered`, {owners});
export const getCustomerProfile = (shipmentId) => api.get(`/shipments/${shipmentId}/customer-profile`);

export const getDashboardItems = () => api.get(`/dashboards`);
export const getDashboardEmbedUrl = (dashboardId) => api.get(`/dashboards/${dashboardId}/embed`);
export const acquireLookerCookielessSession = (dashboardId) => api.post(`/dashboards/cookieless/acquire/${dashboardId}`);
export const refreshLookerCookielessToken = (tokens) => api.put(`/dashboards/cookieless/tokens`, tokens);

export const getCSRFToken = () => api2.get('/csrf/token');

export const updateEmail = ({ email, auth_password }) => api.put('/clients/update-info', { email, auth_password });
export const getListClients = () => dataorchApi.get('/clients/active');
export const updateClientId = (client_id) => api.put('/users/update-client-id', client_id);
export const switchClient = (external_id) => oauth2Api.post('/v1/login/temp-client', {external_id, persist_external_id: true});

export default api;
